import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import BlueButton from "../../../Component/Common/BlueButton";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { BASE_URL } from "../../../config/api";

export default function AddEntityForm() {
  const navigate = useNavigate();
  const { type = "agent" } = useParams();
  const location = useLocation();
  const lead = location.state?.lead || null;
  const leadType = location.state?.leadType || null;
  const roleFromState = leadType;
  const isRetailerUser = location.state?.from === "retailer-user";
  const [submitting, setSubmitting] = useState(false);
  const leadId = lead?.id;



  const [loadingPin, setLoadingPin] = useState(false);

  const LEAD_TYPE_LABELS = {
    2: "Company",
    4: "Agent",
    5: "Retailer",
    6: "Promoter",
  };

  const LEAD_TYPE_VALUES = {
  Company: 2,
  Agent: 4,
  Retailer: 5,
  Promoter: 6,
};


  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;
  const company_id = authUser.company_id;
  const agent_id = authUser.id;
  const agent_code = authUser.company_code;
  const sessionRole = authUser?.role;

  const getPosition = () => {
    if (roleFromState === 6) return "Promoter"; // ✅ ADD THIS

    if (location.state?.from === "retailer-user") return "Promoter";

    if (lead?.lead_type) return LEAD_TYPE_LABELS[lead.lead_type];

    if (roleFromState) return LEAD_TYPE_LABELS[roleFromState];

    return "";
  };
  const safeLead = lead || {};
  // -------------------------
  // FORM STATE
  // -------------------------
  // const [form, setForm] = useState({
  //   first_name: lead?.owner_name?.split(" ")[0] || "",
  //   middle_name: lead?.owner_name?.split(" ")[1] || "",
  //   last_name: lead?.owner_name?.split(" ")[2] || "",
  //   contact_person: lead?.owner_name,

  //   phone_no: lead?.phone || "",
  //   official_email: lead?.email || "",
  //   // position: lead?.lead_type ? LEAD_TYPE_LABELS[lead.lead_type] : "",
  //   position: getPosition(),

  //   address1: lead?.address1 || "",
  //   address2: lead?.address2 || "",
  //   pincode: lead?.pincode || "",
  //   state: lead?.state || "",
  //   district: lead?.district || "",
  //   taluka: "",
  //   city: lead?.district || "",
  //   location: lead?.district || "",

  //   business_name: lead?.name || "",
  //   owner_first: lead?.owner_name?.split(" ")[0] || "",
  //   owner_middle: lead?.owner_name?.split(" ")[1] || "",
  //   owner_last: lead?.owner_name?.split(" ")[2] || "",
  //   owner_contact: lead?.phone || "",
  //   owner_email: lead?.email || "",
  //   role: lead?.lead_type || roleFromState || null,

  //   remark: lead?.remark || "",
  //   // position: isRetailerUser ? "Retailer User" : "",
    
  // });

  const [form, setForm] = useState({
  first_name: safeLead.owner_name?.split(" ")[0] || "",
  middle_name: safeLead.owner_name?.split(" ")[1] || "",
  last_name: safeLead.owner_name?.split(" ")[2] || "",
  contact_person: safeLead.owner_name || "",

  phone_no: safeLead.phone || "",
  official_email: safeLead.email || "",

  position: getPosition(),

  address1: safeLead.address1 || "",
  address2: safeLead.address2 || "",
  pincode: safeLead.pincode || "",
  state: safeLead.state || "",
  district: safeLead.district || "",
  taluka: "",
  city: safeLead.district || "",
  location: safeLead.district || "",

  business_name: safeLead.name || "",

  owner_first: safeLead.owner_name?.split(" ")[0] || "",
  owner_middle: safeLead.owner_name?.split(" ")[1] || "",
  owner_last: safeLead.owner_name?.split(" ")[2] || "",

  owner_contact: safeLead.phone || "",
  owner_email: safeLead.email || "",

  role: safeLead.lead_type || roleFromState || null,

  remark: safeLead.remark || "",
});

  const [errors, setErrors] = useState({});
  const [topErrors, setTopErrors] = useState([]);


  const role = lead?.lead_type ?? roleFromState;
  const isPromoter = roleFromState === 6 || lead?.lead_type === 6;

  const senior_id = authUser?.id || null;

  // -------------------------
  // UNIVERSAL REQUIRED FIELDS
  // -------------------------
  const requiredFields = [
    "first_name",
    "last_name",
    "phone_no",
    "official_email",
    "address1",
    "pincode",
    "business_name",
    "owner_first",
    "owner_last",
    "owner_contact",
    "owner_email",
    // "pan_no",
  ];

  // -------------------------
  // HANDLE INPUT
  // -------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    validateField(name, value);

    if (name === "pincode" && value.length === 6) fetchPinDetails(value);
  };

  // -------------------------
  // FETCH PINCODE DETAILS
  // -------------------------
  const fetchPinDetails = async (pincode) => {
    try {
      setLoadingPin(true);
      const res = await axios.get(
        `https://goelectronix.in/public/api/v1/pincode/${pincode}`
      );

      if (res.data?.success) {
        setForm((prev) => ({
          ...prev,
          state: res.data.state,
          district: res.data.district,
          city: res.data.city || "",
          taluka: res.data.taluka || "",
        }));
        setErrors((prev) => ({ ...prev, pincode: "" }));
      } else {
        setErrors((p) => ({ ...p, pincode: "Invalid pincode" }));
        Swal.fire("Invalid Pincode", "Please enter correct pincode.", "error");
      }
    } catch {
      Swal.fire("Error", "Unable to fetch pincode details.", "error");
    } finally {
      setLoadingPin(false);
    }
  };

  // -------------------------
  // VALIDATE A FIELD
  // -------------------------
  const validateField = (name, value) => {
  let error = "";

  const val = value ?? ""; // default to empty string if undefined or null

  // Required check
  if (requiredFields.includes(name) && !val.trim()) {
    error = "This field is required";
  }

  if (val.trim()) {
    if (["phone_no", "owner_contact"].includes(name)) {
      if (!/^[6-9]\d{9}$/.test(val)) error = "Invalid 10-digit phone";
    }

    if (["official_email", "owner_email"].includes(name)) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) error = "Invalid email format";
    }

    // if (name === "pan_no" && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(val)) {
    //   error = "Invalid PAN format";
    // }

    if (name === "pincode" && val.length !== 6) {
      error = "Pincode must be 6 digits";
    }
  }

  setErrors((prev) => ({ ...prev, [name]: error }));
  return error === "";
};


  // -------------------------
  // VALIDATE FULL FORM
  // -------------------------
  const validateForm = () => {
    let valid = true;
    let collectedErrors = [];

    requiredFields.forEach((field) => {
      if (!validateField(field, form[field])) {
        valid = false;
        collectedErrors.push(`${field} is invalid or empty`);
      }
    });

    setTopErrors(collectedErrors);
    return valid;
  };


  const getCompanyId = () => {
  const role = authUser?.role;

  if (role === 1) return null;                 // Super Admin
  if (role === 2) return authUser?.id || null; // Company
  if (role === 3 || role === 4)
    return authUser?.company_id || null;       // CNF / Agent

  return null;
};

  const shouldAttachBranding =
  sessionRole === 2 &&
  (lead?.lead_type === 4 || lead?.lead_type === 5);


const handleSubmit = async (e) => {

  const isPromoter = roleFromState === 6 || lead?.lead_type === 6;  
  e.preventDefault();

  if (!validateForm()) {
    toast.error("Please fix the highlighted errors");
    return;
  }

 if (!leadId && !isPromoter) {
  toast.error("Lead ID missing");
  return;
}

  setSubmitting(true);

  const payload = {
    name: form.business_name,
    phone: form.phone_no,
    email: form.official_email,

    state: form.state,
    district: form.district,
    pincode: form.pincode,
    address1: form.address1,
    address2: form.address2,

    status: 1, // you can make dynamic if needed
    lead_amount: lead?.lead_amount || 0,

    created_by_id: isPromoter
      ? authUser?.id
      : lead?.created_by_id,

    created_by_name: isPromoter
      ? authUser?.business_name
      : lead?.created_by_name,

    updated_by_id:authUser?.id,
    updated_by_name: authUser?.business_name || authUser?.name,

    owner_name: `${form.first_name} ${form.middle_name || ""} ${form.last_name}`.trim(),
    owner_first_name:form.first_name,    
    owner_middle_name:form.middle_name,    
    owner_last_name:form.last_name,    
    lead_type:
      LEAD_TYPE_VALUES[form.position] ||
      lead?.lead_type ||
      roleFromState,

    package_id: lead?.package_id || null,
    package_name: lead?.package_name || null,

    badge_name: lead?.badge_name || null,
    badge_id: lead?.badge_id || null,

    benefits: lead?.benefits || null,
    eligibility: lead?.eligibility || null,

    // company_id: authUser?.company_id || null,
    manager_id: lead?.manager_id || null,
    agent_id: lead?.agent_id || null,

    pay_now: lead?.pay_now ?? 0,
    pay_later: lead?.pay_later ?? 0,
  };

  try {
    let endpoint = "";
    let finalPayload = {};

    if (isPromoter) {
      // 🔥 PROMOTER → common/update
      endpoint = `${BASE_URL}common/update`;

      finalPayload = {
        flag: "retailer-user",

        company_id:
          authUser?.role === 2
            ? authUser?.id
            : authUser?.company_id || null,

        first_name: form.first_name,
        middle_name: form.middle_name,
        last_name: form.last_name,

        owner_first_name: form.owner_first,
        owner_middle_name: form.owner_middle,
        owner_last_name: form.owner_last,

        business_name: form.business_name,
        owner_contact: form.owner_contact,
        owner_email: form.owner_email,

        contact_email: form.owner_email,
        email: form.official_email,
        contact_phone: form.phone_no,
        contact_person: `${form.first_name} ${form.last_name}`,

        password: "123456",

        address_line1: form.address1,
        address_line2: form.address2,
        city: form.city,
        district: form.district,
        state: form.state,
        location: form.location,
        taluka: form.taluka,
        pincode: form.pincode,

        remark: form.remark,

        role: 6, // ✅ PROMOTER

        created_by_id: authUser?.id,
        created_by_name: authUser?.business_name,
        senior_id:authUser?.id,
        pay_now:authUser?.pay_now,
        pay_later: authUser?.pay_later,
        admin_paynow_status: authUser?.admin_paynow_status,
        admin_paylater_status: authUser?.admin_paylater_status,
      };
    } else {
      // 🔁 EXISTING FLOW (NO CHANGE)
      endpoint = `${BASE_URL}warranty/wlead/update/${leadId}`;
      finalPayload = payload;
    }

    const res = await axios.post(endpoint, finalPayload);

    if (res.data?.status) {
      toast.success(
        isPromoter
          ? "Promoter created successfully 🎉"
          : "Lead updated successfully"
      );

      navigate(isPromoter ? "/retuser" : "/empdashboard");
    } else {
      toast.error(res.data?.message || "Failed");
    }
  } catch (error) {
    console.error("Error:", error);
    toast.error("Something went wrong");
  } finally {
    setSubmitting(false);
  }
};


  // -------------------------
  // INPUT COMPONENT
  // -------------------------
  const renderInput = (label, name, inputType = "text", readOnly = false) => (
    <div>
      <label className="block text-sm font-medium text-slate-700">{label}</label>

      <input
        type={inputType}
        name={name}
        value={form[name]}
        onChange={handleChange}
        readOnly={readOnly}
        maxLength={name === "pincode" ? 6 : undefined}
        className={`mt-1 px-3 py-2 border rounded-lg w-full text-sm 
          ${readOnly ? "bg-gray-100" : ""}
          ${errors[name] ? "border-red-500" : "border-slate-300"}`}
      />

      {errors[name] && <p className="text-xs text-red-500">{errors[name]}</p>}
      {loadingPin && name === "pincode" && (
        <p className="text-xs text-blue-600">Fetching...</p>
      )}
    </div>
  );

  return (
    <div className="mx-auto bg-white shadow-md rounded-2xl p-5 m-4 mb-10">
      <h2 className="text-2xl font-semibold text-primary mb-4">
        {lead?.lead_type
          ? `Add New ${LEAD_TYPE_LABELS[lead.lead_type]}`
          : roleFromState
            ? `Add New ${LEAD_TYPE_LABELS[roleFromState] || "Promoter"}`
            : `Add New Agent`}
      </h2>



      {topErrors.length > 0 && (
        <div className="bg-red-100 border border-red-300 text-red-700 px-4 py-3 rounded mb-4">
          <p className="font-semibold">Please fix the following errors:</p>
          <ul className="list-disc ml-6 mt-1">
            {topErrors.map((err, i) => (
              <li key={i}>{err}</li>
            ))}
          </ul>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* PERSONAL */}
        <div>
          <h3 className="font-semibold text-lg mb-2">Personal Details</h3>
          <div className="grid md:grid-cols-3 gap-4">
            {renderInput("First Name", "first_name")}
            {renderInput("Middle Name", "middle_name")}
            {renderInput("Last Name", "last_name")}
            {renderInput("Phone Number", "phone_no")}
            {renderInput("Official Email", "official_email", "email")}
            {renderInput("Position", "position", "text", true)}
          </div>
        </div>

        {/* ADDRESS */}
        <div>
          <h3 className="font-semibold text-lg mb-2">Address Details</h3>
          <div className="grid md:grid-cols-3 gap-4">
            {renderInput("Address Line 1", "address1")}
            {renderInput("Address Line 2", "address2")}
            {renderInput("Pincode", "pincode")}
            {renderInput("State", "state", "text", true)}
            {renderInput("District", "district", "text", true)}
            {/* {renderInput("Taluka", "taluka")} */}
            {renderInput("City", "city")}
            {renderInput("Location", "location")}
          </div>
        </div>

        {/* BUSINESS */}
        <div>
          <h3 className="font-semibold text-lg mb-2">Business Details</h3>
          <div className="grid md:grid-cols-3 gap-4">
            {renderInput("Business Name", "business_name")}
            {renderInput("Owner First Name", "owner_first")}
            {renderInput("Owner Middle Name", "owner_middle")}
            {renderInput("Owner Last Name", "owner_last")}
            {renderInput("Owner Contact", "owner_contact")}
            {renderInput("Owner Email", "owner_email", "email")}
            {/* {renderInput("PAN Number", "pan_no")} */}
            {lead?.remark && renderInput("Remark", "remark")}
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <BlueButton
            type="button"
            disabled={submitting}
            onClick={() => navigate(`/empdashboard`)}
          >
            Cancel
          </BlueButton>
          <BlueButton
            type="submit"
            disabled={submitting}
            className={`${submitting ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            {submitting
              ? isPromoter
                ? "Adding..."
                : "Updating..."
              : isPromoter
                ? "Add"
                : "Update"}
          </BlueButton>
        </div>
      </form>
    </div>
  );
}


// *************************************working code for lead update*****************************************************

// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import BlueButton from "../../../Component/Common/BlueButton";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import toast from "react-hot-toast";
// import { BASE_URL } from "../../../config/api";

// export default function AddEntityForm() {
//   const navigate = useNavigate();
//   const { type = "agent" } = useParams();
//   const location = useLocation();
//   const lead = location.state?.lead || null;
//   const leadType = location.state?.leadType || null;
//   const roleFromState = leadType;
//   const isRetailerUser = type === "retailer-user";
//   const [submitting, setSubmitting] = useState(false);
//   const leadId = lead?.id;



//   const [loadingPin, setLoadingPin] = useState(false);

//   const LEAD_TYPE_LABELS = {
//     2: "Company",
//     4: "Agent",
//     5: "Retailer",
//     6: "Promoter",
//   };

//   const LEAD_TYPE_VALUES = {
//   Company: 2,
//   Agent: 4,
//   Retailer: 5,
//   Promoter: 6,
// };


//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;
//   const company_id = authUser.company_id;
//   const agent_id = authUser.id;
//   const agent_code = authUser.company_code;
//   const sessionRole = authUser?.role;

//   // -------------------------
//   // FORM STATE
//   // -------------------------
//   const [form, setForm] = useState({
//     first_name: lead?.owner_name?.split(" ")[0] || "",
//     middle_name: lead?.owner_name?.split(" ")[1] || "",
//     last_name: lead?.owner_name?.split(" ")[2] || "",
//     contact_person: lead?.owner_name,

//     phone_no: lead?.phone || "",
//     official_email: lead?.email || "",
//     // position: lead?.lead_type ? LEAD_TYPE_LABELS[lead.lead_type] : "",
//     position: isRetailerUser
//   ? "Promoter"
//   : lead?.lead_type
//     ? LEAD_TYPE_LABELS[lead.lead_type]
//     : "",

//     address1: lead?.address1 || "",
//     address2: lead?.address2 || "",
//     pincode: lead?.pincode || "",
//     state: lead?.state || "",
//     district: lead?.district || "",
//     taluka: "",
//     city: lead?.district || "",
//     location: lead?.district || "",

//     business_name: lead?.name || "",
//     owner_first: lead?.owner_name?.split(" ")[0] || "",
//     owner_middle: lead?.owner_name?.split(" ")[1] || "",
//     owner_last: lead?.owner_name?.split(" ")[2] || "",
//     owner_contact: lead?.phone || "",
//     owner_email: lead?.email || "",
//     role: lead?.lead_type || roleFromState || null,

//     remark: lead?.remark || "",
//     // position: isRetailerUser ? "Retailer User" : "",
    
//   });

//   const [errors, setErrors] = useState({});
//   const [topErrors, setTopErrors] = useState([]);


//   const role = lead?.lead_type ?? roleFromState;

//   const senior_id = authUser?.id || null;

//   // -------------------------
//   // UNIVERSAL REQUIRED FIELDS
//   // -------------------------
//   const requiredFields = [
//     "first_name",
//     "last_name",
//     "phone_no",
//     "official_email",
//     "address1",
//     "pincode",
//     "business_name",
//     "owner_first",
//     "owner_last",
//     "owner_contact",
//     "owner_email",
//     // "pan_no",
//   ];

//   // -------------------------
//   // HANDLE INPUT
//   // -------------------------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((p) => ({ ...p, [name]: value }));
//     validateField(name, value);

//     if (name === "pincode" && value.length === 6) fetchPinDetails(value);
//   };

//   // -------------------------
//   // FETCH PINCODE DETAILS
//   // -------------------------
//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);
//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           city: res.data.city || "",
//           taluka: res.data.taluka || "",
//         }));
//         setErrors((prev) => ({ ...prev, pincode: "" }));
//       } else {
//         setErrors((p) => ({ ...p, pincode: "Invalid pincode" }));
//         Swal.fire("Invalid Pincode", "Please enter correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   // -------------------------
//   // VALIDATE A FIELD
//   // -------------------------
//   const validateField = (name, value) => {
//   let error = "";

//   const val = value ?? ""; // default to empty string if undefined or null

//   // Required check
//   if (requiredFields.includes(name) && !val.trim()) {
//     error = "This field is required";
//   }

//   if (val.trim()) {
//     if (["phone_no", "owner_contact"].includes(name)) {
//       if (!/^[6-9]\d{9}$/.test(val)) error = "Invalid 10-digit phone";
//     }

//     if (["official_email", "owner_email"].includes(name)) {
//       if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) error = "Invalid email format";
//     }

//     // if (name === "pan_no" && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(val)) {
//     //   error = "Invalid PAN format";
//     // }

//     if (name === "pincode" && val.length !== 6) {
//       error = "Pincode must be 6 digits";
//     }
//   }

//   setErrors((prev) => ({ ...prev, [name]: error }));
//   return error === "";
// };


//   // -------------------------
//   // VALIDATE FULL FORM
//   // -------------------------
//   const validateForm = () => {
//     let valid = true;
//     let collectedErrors = [];

//     requiredFields.forEach((field) => {
//       if (!validateField(field, form[field])) {
//         valid = false;
//         collectedErrors.push(`${field} is invalid or empty`);
//       }
//     });

//     setTopErrors(collectedErrors);
//     return valid;
//   };


//   const getCompanyId = () => {
//   const role = authUser?.role;

//   if (role === 1) return null;                 // Super Admin
//   if (role === 2) return authUser?.id || null; // Company
//   if (role === 3 || role === 4)
//     return authUser?.company_id || null;       // CNF / Agent

//   return null;
// };

//   const shouldAttachBranding =
//   sessionRole === 2 &&
//   (lead?.lead_type === 4 || lead?.lead_type === 5);


//   // -------------------------
//   // SUBMIT
//   // -------------------------
// //   const handleSubmit = async (e) => {
// //   e.preventDefault();

// //   // 🔍 Validate form before submit
// //   if (!validateForm()) {
// //     toast.error("Please fix the highlighted errors");
// //     return;
// //   }

// //   setSubmitting(true); // 🔵 START LOADING

// //   // 📦 Prepare payload
// //   const payload = {
// //     flag: type,
// //     company_id: getCompanyId(),

// //     first_name: form.first_name,
// //     middle_name: form.middle_name,
// //     last_name: form.last_name,

// //     owner_first_name: form.owner_first,
// //     owner_middle_name: form.owner_middle,
// //     owner_last_name: form.owner_last,

// //     business_name: form.business_name,
// //     owner_contact: form.owner_contact,
// //     owner_email: form.owner_email,

// //     contact_email: form.official_email, // ✅ synced
// //     email: form.official_email,
// //     contact_phone: form.phone_no,
// //     contact_person: lead?.owner_name || "",

// //     password: "123456",

// //     address_line1: form.address1,
// //     address_line2: form.address2,
// //     city: form.city,
// //     district: form.district,
// //     state: form.state,
// //     location: form.location,
// //     taluka: form.taluka,
// //     pincode: form.pincode,

// //     pan_number: form.pan_no || null,
// //     gst: form.gst || null,
// //     remark: form.remark || null,
// //     agent_code: lead?.agent_code,
// //     agent_id: lead?.agent_id,
// //     role: lead?.lead_type ?? roleFromState,
// //     senior_id: authUser?.id || null,
// //     // ✅ ADD THESE TWO LINES
// //     pay_now: lead?.pay_now ?? 0,
// //     pay_later: lead?.pay_later ?? 0,

// //     // 🔥 CONDITIONAL BRANDING (ONLY ROLE 2 → AGENT / RETAILER)
// //   ...(shouldAttachBranding && {
// //     logo: authUser?.logo || null,
// //     domain: authUser?.domain || null,
// //     title: authUser?.title || null,
// //     created_by_id: lead?.created_by_id,
// //     created_by_name: lead?.created_by_name,
// //   }),
// //   };

// //   try {
// //     const res = await axios.post(`${BASE_URL}common/update`, payload);

// //     // ✅ CORRECT SUCCESS CHECK
// //     if (res.data?.status) {
// //       toast.success(res.data.message || "Saved successfully");

// //       if (sessionRole === 4) {
// //         // Agent login → go to Agent Retailers page
// //         navigate("/agentretailers");
// //         return;
// //       }

// //       // 🧭 Role-based redirect
// //       const roleLabel =
// //         LEAD_TYPE_LABELS[lead?.lead_type] ||
// //         (type === "retailer-user" ? "Retailer" : "");

// //       if (roleLabel === "Company") {
// //         navigate("/employee-dashboard");
// //       } else if (roleLabel === "Agent") {
// //         navigate("/employee-dashboard");
// //       } else if (roleLabel === "Retailer") {
// //         navigate("/employee-dashboard");
// //       } else {
// //         navigate("/");
// //       }
// //     } else {
// //       toast.error(res.data?.message || "Something went wrong");
// //     }
// //   } catch (error) {
// //     console.error("Save error:", error);
// //     toast.error("Failed to save data");
// //   }
// //   finally {
// //     setSubmitting(false); // 🟢 STOP LOADING (always)
// //   }
// // };


// const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!validateForm()) {
//     toast.error("Please fix the highlighted errors");
//     return;
//   }

//   if (!leadId) {
//     toast.error("Lead ID missing");
//     return;
//   }

//   setSubmitting(true);

//   const payload = {
//     name: form.business_name,
//     phone: form.phone_no,
//     email: form.official_email,

//     state: form.state,
//     district: form.district,
//     pincode: form.pincode,
//     address1: form.address1,
//     address2: form.address2,

//     status: 1, // you can make dynamic if needed
//     lead_amount: lead?.lead_amount || 0,

//     created_by_id: lead?.created_by_id,
//     created_by_name: lead?.created_by_name,

//     updated_by_id:authUser?.id,
//     updated_by_name: authUser?.business_name || authUser?.name,

//     owner_name: `${form.first_name} ${form.middle_name || ""} ${form.last_name}`.trim(),
//     owner_first_name:form.first_name,    
//     owner_middle_name:form.middle_name,    
//     owner_last_name:form.last_name,    
//     lead_type:
//       LEAD_TYPE_VALUES[form.position] ||
//       lead?.lead_type ||
//       roleFromState,

//     package_id: lead?.package_id || null,
//     package_name: lead?.package_name || null,

//     badge_name: lead?.badge_name || null,
//     badge_id: lead?.badge_id || null,

//     benefits: lead?.benefits || null,
//     eligibility: lead?.eligibility || null,

//     // company_id: authUser?.company_id || null,
//     manager_id: lead?.manager_id || null,
//     agent_id: lead?.agent_id || null,

//     pay_now: lead?.pay_now ?? 0,
//     pay_later: lead?.pay_later ?? 0,
//   };

//   try {
//     const res = await axios.post(
//       `${BASE_URL}warranty/wlead/update/${leadId}`,
//       payload
//     );

//     if (res.data?.status) {
//       toast.success("Lead updated successfully");

//       navigate("/empdashboard");
//     } else {
//       toast.error(res.data?.message || "Update failed");
//     }
//   } catch (error) {
//     console.error("Update error:", error);
//     toast.error("Failed to update lead");
//   } finally {
//     setSubmitting(false);
//   }
// };


//   // -------------------------
//   // INPUT COMPONENT
//   // -------------------------
//   const renderInput = (label, name, inputType = "text", readOnly = false) => (
//     <div>
//       <label className="block text-sm font-medium text-slate-700">{label}</label>

//       <input
//         type={inputType}
//         name={name}
//         value={form[name]}
//         onChange={handleChange}
//         readOnly={readOnly}
//         maxLength={name === "pincode" ? 6 : undefined}
//         className={`mt-1 px-3 py-2 border rounded-lg w-full text-sm 
//           ${readOnly ? "bg-gray-100" : ""}
//           ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//       />

//       {errors[name] && <p className="text-xs text-red-500">{errors[name]}</p>}
//       {loadingPin && name === "pincode" && (
//         <p className="text-xs text-blue-600">Fetching...</p>
//       )}
//     </div>
//   );

//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-5 m-4 mb-10">
//       <h2 className="text-2xl font-semibold text-primary mb-4">
//         {lead?.lead_type
//           ? `Add New ${LEAD_TYPE_LABELS[lead.lead_type]}`
//           : roleFromState
//             ? `Add New ${LEAD_TYPE_LABELS[roleFromState] || "Promoter"}`
//             : `Add New Agent`}
//       </h2>



//       {topErrors.length > 0 && (
//         <div className="bg-red-100 border border-red-300 text-red-700 px-4 py-3 rounded mb-4">
//           <p className="font-semibold">Please fix the following errors:</p>
//           <ul className="list-disc ml-6 mt-1">
//             {topErrors.map((err, i) => (
//               <li key={i}>{err}</li>
//             ))}
//           </ul>
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* PERSONAL */}
//         <div>
//           <h3 className="font-semibold text-lg mb-2">Personal Details</h3>
//           <div className="grid md:grid-cols-3 gap-4">
//             {renderInput("First Name", "first_name")}
//             {renderInput("Middle Name", "middle_name")}
//             {renderInput("Last Name", "last_name")}
//             {renderInput("Phone Number", "phone_no")}
//             {renderInput("Official Email", "official_email", "email")}
//             {renderInput("Position", "position", "text", true)}
//           </div>
//         </div>

//         {/* ADDRESS */}
//         <div>
//           <h3 className="font-semibold text-lg mb-2">Address Details</h3>
//           <div className="grid md:grid-cols-3 gap-4">
//             {renderInput("Address Line 1", "address1")}
//             {renderInput("Address Line 2", "address2")}
//             {renderInput("Pincode", "pincode")}
//             {renderInput("State", "state", "text", true)}
//             {renderInput("District", "district", "text", true)}
//             {/* {renderInput("Taluka", "taluka")} */}
//             {renderInput("City", "city")}
//             {renderInput("Location", "location")}
//           </div>
//         </div>

//         {/* BUSINESS */}
//         <div>
//           <h3 className="font-semibold text-lg mb-2">Business Details</h3>
//           <div className="grid md:grid-cols-3 gap-4">
//             {renderInput("Business Name", "business_name")}
//             {renderInput("Owner First Name", "owner_first")}
//             {renderInput("Owner Middle Name", "owner_middle")}
//             {renderInput("Owner Last Name", "owner_last")}
//             {renderInput("Owner Contact", "owner_contact")}
//             {renderInput("Owner Email", "owner_email", "email")}
//             {/* {renderInput("PAN Number", "pan_no")} */}
//             {lead?.remark && renderInput("Remark", "remark")}
//           </div>
//         </div>

//         <div className="flex justify-end gap-3">
//           <BlueButton
//             type="button"
//             disabled={submitting}
//             onClick={() => navigate(`/${type}s`)}
//           >
//             Cancel
//           </BlueButton>
//           <BlueButton
//               type="submit"
//               disabled={submitting}
//               className={`${submitting ? "opacity-60 cursor-not-allowed" : ""}`}
//             >
//               {submitting ? "Updating..." : "Update"}
//             </BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }

//********************************************************Working Code*************************************************** */



// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import BlueButton from "../../../Component/Common/BlueButton";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import toast from "react-hot-toast";
// import { BASE_URL } from "../../../config/api";

// export default function AddEntityForm() {
//   const navigate = useNavigate();
//   const { type = "agent" } = useParams();
//   const location = useLocation();
//   const lead = location.state?.lead || null;

//   const [loadingPin, setLoadingPin] = useState(false);

//   const LEAD_TYPE_LABELS = {
//     2: "Company",
//     4: "Agent",
//     5: "Retailer",
//   };

//   // -------------------------
//   // FORM STATE
//   // -------------------------
//   const [form, setForm] = useState({
//     first_name: lead?.owner_name?.split(" ")[0] || "",
//     middle_name: lead?.owner_name?.split(" ")[1] || "",
//     last_name: lead?.owner_name?.split(" ")[2] || "",
//     contact_person: lead?.owner_name,

//     phone_no: lead?.phone || "",
//     official_email: lead?.email || "",
//     position: lead?.lead_type ? LEAD_TYPE_LABELS[lead.lead_type] : "",
//     address1: lead?.address_full || "",
//     address2: "",
//     pincode: lead?.pincode || "",
//     state: lead?.state || "",
//     district: lead?.district || "",
//     taluka: "",
//     city: lead?.district || "",
//     location: lead?.district || "",

//     business_name: lead?.name || "",
//     owner_first: lead?.owner_name?.split(" ")[0] || "",
//     owner_middle: lead?.owner_name?.split(" ")[1] || "",
//     owner_last: lead?.owner_name?.split(" ")[2] || "",
//     owner_contact: lead?.phone || "",
//     owner_email: lead?.email || "",
//     role: lead?.lead_type,

//     remark: lead?.remark || "",
//   });

//   const [errors, setErrors] = useState({});
//   const [topErrors, setTopErrors] = useState([]);

//   // -------------------------
//   // UNIVERSAL REQUIRED FIELDS
//   // -------------------------
//   const requiredFields = [
//     "first_name",
//     "last_name",
//     "phone_no",
//     "official_email",
//     "address1",
//     "pincode",
//     "business_name",
//     "owner_first",
//     "owner_last",
//     "owner_contact",
//     "owner_email",
//     // "pan_no",
//   ];

//   // -------------------------
//   // HANDLE INPUT
//   // -------------------------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((p) => ({ ...p, [name]: value }));
//     validateField(name, value);

//     if (name === "pincode" && value.length === 6) fetchPinDetails(value);
//   };

//   // -------------------------
//   // FETCH PINCODE DETAILS
//   // -------------------------
//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);
//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           city: res.data.city || "",
//           taluka: res.data.taluka || "",
//         }));
//         setErrors((prev) => ({ ...prev, pincode: "" }));
//       } else {
//         setErrors((p) => ({ ...p, pincode: "Invalid pincode" }));
//         Swal.fire("Invalid Pincode", "Please enter correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   // -------------------------
//   // VALIDATE A FIELD
//   // -------------------------
//   const validateField = (name, value) => {
//   let error = "";

//   const val = value ?? ""; // default to empty string if undefined or null

//   // Required check
//   if (requiredFields.includes(name) && !val.trim()) {
//     error = "This field is required";
//   }

//   if (val.trim()) {
//     if (["phone_no", "owner_contact"].includes(name)) {
//       if (!/^[6-9]\d{9}$/.test(val)) error = "Invalid 10-digit phone";
//     }

//     if (["official_email", "owner_email"].includes(name)) {
//       if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) error = "Invalid email format";
//     }

//     // if (name === "pan_no" && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(val)) {
//     //   error = "Invalid PAN format";
//     // }

//     if (name === "pincode" && val.length !== 6) {
//       error = "Pincode must be 6 digits";
//     }
//   }

//   setErrors((prev) => ({ ...prev, [name]: error }));
//   return error === "";
// };


//   // -------------------------
//   // VALIDATE FULL FORM
//   // -------------------------
//   const validateForm = () => {
//     let valid = true;
//     let collectedErrors = [];

//     requiredFields.forEach((field) => {
//       if (!validateField(field, form[field])) {
//         valid = false;
//         collectedErrors.push(`${field} is invalid or empty`);
//       }
//     });

//     setTopErrors(collectedErrors);
//     return valid;
//   };

//   // -------------------------
//   // SUBMIT
//   // -------------------------
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       Swal.fire("Error", "Fix the highlighted errors.", "error");
//       return;
//     }

//     const payload = {
//       flag: type,
//       company_id: type === "company" ? null : 1,

//       first_name: form.first_name,
//       middle_name: form.middle_name,
//       last_name: form.last_name,

//       owner_first_name: form.owner_first,
//       owner_middle_name: form.owner_middle,
//       owner_last_name: form.owner_last,

//       business_name: form.business_name,
//       owner_contact: form.owner_contact,
//       owner_email: form.owner_email,
//       contact_email: form.owner_email,
//       email: form.official_email,
//       contact_phone: form.phone_no,
//       contact_person: lead?.owner_name,
//       password: "123456",

//       address_line1: form.address1,
//       address_line2: form.address2,
//       city: form.city,
//       district: form.district,
//       state: form.state,
//       location: form.location,
//       taluka: form.taluka,
//       pincode: form.pincode,

//       pan_number: form.pan_no,
//       gst: form.gst,
//       remark: form.remark,
//       role: lead?.lead_type,
//     };

//     try {
//       const res = await axios.post(
//         `${BASE_URL}common/update`,
//         payload
//       );

//       if (res.data.status) {
//         toast.success(`${LEAD_TYPE_LABELS[lead.lead_type]} created successfully!`);

//         if (LEAD_TYPE_LABELS === "company") {
//           navigate("/amdcomp");
//         } else if (LEAD_TYPE_LABELS === "agent") {
//           navigate("/admagents");
//         } else if (LEAD_TYPE_LABELS === "retailer") {
//           navigate("/admretailers");
//         } else {
//           navigate("/"); // fallback safety
//         }
//       } else {
//         toast.error(res.data.message);
//       }
//     } catch {
//       Swal.fire("Error", "Failed to save data.", "error");
//     }
//   };

//   // -------------------------
//   // INPUT COMPONENT
//   // -------------------------
//   const renderInput = (label, name, inputType = "text", readOnly = false) => (
//     <div>
//       <label className="block text-sm font-medium text-slate-700">{label}</label>

//       <input
//         type={inputType}
//         name={name}
//         value={form[name]}
//         onChange={handleChange}
//         readOnly={readOnly}
//         maxLength={name === "pincode" ? 6 : undefined}
//         className={`mt-1 px-3 py-2 border rounded-lg w-full text-sm 
//           ${readOnly ? "bg-gray-100" : ""}
//           ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//       />

//       {errors[name] && <p className="text-xs text-red-500">{errors[name]}</p>}
//       {loadingPin && name === "pincode" && (
//         <p className="text-xs text-blue-600">Fetching...</p>
//       )}
//     </div>
//   );

//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-5 m-4 mb-10">
//       <h2 className="text-2xl font-semibold text-primary mb-4">
//         Add New {type}
//       </h2>

//       {topErrors.length > 0 && (
//         <div className="bg-red-100 border border-red-300 text-red-700 px-4 py-3 rounded mb-4">
//           <p className="font-semibold">Please fix the following errors:</p>
//           <ul className="list-disc ml-6 mt-1">
//             {topErrors.map((err, i) => (
//               <li key={i}>{err}</li>
//             ))}
//           </ul>
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* PERSONAL */}
//         <div>
//           <h3 className="font-semibold text-lg mb-2">Personal Details</h3>
//           <div className="grid md:grid-cols-3 gap-4">
//             {renderInput("First Name", "first_name")}
//             {renderInput("Middle Name", "middle_name")}
//             {renderInput("Last Name", "last_name")}
//             {renderInput("Phone Number", "phone_no")}
//             {renderInput("Official Email", "official_email", "email")}
//             {renderInput("Position", "position", "text", true)}
//           </div>
//         </div>

//         {/* ADDRESS */}
//         <div>
//           <h3 className="font-semibold text-lg mb-2">Address Details</h3>
//           <div className="grid md:grid-cols-3 gap-4">
//             {renderInput("Address Line 1", "address1")}
//             {renderInput("Address Line 2", "address2")}
//             {renderInput("Pincode", "pincode")}
//             {renderInput("State", "state", "text", true)}
//             {renderInput("District", "district", "text", true)}
//             {renderInput("Taluka", "taluka")}
//             {renderInput("City", "city")}
//             {renderInput("Location", "location")}
//           </div>
//         </div>

//         {/* BUSINESS */}
//         <div>
//           <h3 className="font-semibold text-lg mb-2">Business Details</h3>
//           <div className="grid md:grid-cols-3 gap-4">
//             {renderInput("Business Name", "business_name")}
//             {renderInput("Owner First Name", "owner_first")}
//             {renderInput("Owner Middle Name", "owner_middle")}
//             {renderInput("Owner Last Name", "owner_last")}
//             {renderInput("Owner Contact", "owner_contact")}
//             {renderInput("Owner Email", "owner_email", "email")}
//             {/* {renderInput("PAN Number", "pan_no")} */}
//             {lead?.remark && renderInput("Remark", "remark")}
//           </div>
//         </div>

//         <div className="flex justify-end gap-3">
//           <BlueButton onClick={() => navigate(`/${type}s`)} type="button">
//             Cancel
//           </BlueButton>
//           <BlueButton type="submit">Save</BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import BlueButton from "../../../Component/Common/BlueButton";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import toast from "react-hot-toast";

// export default function AddEntityForm() {
//   const navigate = useNavigate();
//   const { type = "agent" } = useParams(); // default type
//   const location = useLocation();
//   const lead = location.state?.lead || null; // lead data from previous page
//   console.log("lead data: ",lead)
//   const [loadingPin, setLoadingPin] = useState(false);
//   // const { type: rawType } = useParams();
//   // const type = rawType || "agent";

//   // --- FORM STATE ---
//   const [form, setForm] = useState({
//     first_name: lead?.owner_name.split(" ")[0] || "",
//     middle_name: lead?.owner_name?.split(" ")[1] || "",
//     last_name: lead?.owner_name?.split(" ")[2] || "",

//     phone_no: lead?.phone || "",
//     official_email: lead?.email || "",
//     position: lead?.lead_type || "",
//     address1: lead?.address_full || "",
//     address2: "",
//     pincode: lead?.pincode || "",
//     state: lead?.state || "",
//     district: lead?.district || "",
//     taluka: "",
//     city: lead?.district || "",
//     location: lead?.district || "",

//     business_name: lead?.name || "",
//     owner_first: lead?.owner_name?.split(" ")[0] || "",
//     owner_middle: lead?.owner_name?.split(" ")[1] || "",
//     owner_last: lead?.owner_name?.split(" ")[2] || "",
//     owner_contact: lead?.phone || "",
//     owner_email: lead?.email || "",
//     pan_no: "",

//     company_name: "",
//     contact_person: "",
//     contact_phone: "",
//     contact_email: "",
//     pan: "",
//     gst: "",
//     business_type: "Unregister",

//     remark: lead?.remark || "", // remark from won lead
//   });

//   const [errors, setErrors] = useState({});

//   // REQUIRED FIELDS BY TYPE
//   const requiredFieldsByType = {
//     agent: [
//       "first_name",
//       "last_name",
//       "phone_no",
//       "official_email",
//       "position",
//       "address1",
//       "pincode",
//     ],

//     retailer: [
//       "business_name",
//       "owner_first",
//       "owner_last",
//       "owner_contact",
//       "owner_email",
//       "pincode",
//       "pan_no",
//     ],

//     company: [
//       "company_name",
//       "contact_person",
//       "contact_phone",
//       "contact_email",
//       "pan",
//       "gst",
//       "pincode",
//     ],
//   };

//   // HANDLE INPUT CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));

//     if (name === "pincode" && value.length === 6) fetchPinDetails(value);
//     validateField(name, value);
//   };

//   // FETCH PINCODE
//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);
//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           city: res.data.city || "",
//           taluka: res.data.taluk || "",
//         }));
//         setErrors((prev) => ({ ...prev, pincode: "" }));
//       } else {
//         setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
//         Swal.fire("Invalid Pincode", "Enter a correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   // VALIDATE SINGLE FIELD
//   const validateField = (name, value) => {
//     let error = "";
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[6-9]\d{9}$/;
//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

//     const requiredFields = requiredFieldsByType[type] || [];

//     if (requiredFields.includes(name) && !value.trim()) error = "This field is required";

//     if (value.trim()) {
//       if (["phone_no", "owner_contact", "contact_phone"].includes(name)) {
//         if (!phoneRegex.test(value)) error = "Invalid 10-digit phone number";
//       }
//       if (["official_email", "owner_email", "contact_email"].includes(name)) {
//         if (!emailRegex.test(value)) error = "Invalid email format";
//       }
//       if (["pan", "pan_no"].includes(name) && !panRegex.test(value)) {
//         error = "Invalid PAN format";
//       }
//       if (name === "pincode" && value.length !== 6) {
//         error = "Pincode must be 6 digits";
//       }
//     }

//     setErrors((prev) => ({ ...prev, [name]: error }));
//     return error === "";
//   };

//   // VALIDATE ENTIRE FORM
//   const validateForm = () => {
//     let valid = true;
//     const required = requiredFieldsByType[type] || [];
//     required.forEach((field) => {
//       if (!validateField(field, form[field])) valid = false;
//     });
//     return valid;
//   };

//   // SUBMIT FORM
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       Swal.fire("Error", "Fix validation errors before submitting.", "error");
//       return;
//     }

//     const payload = {
//       flag: type,
//       company_id: type === "company" ? null : 1,

//       first_name: form.first_name,
//       middle_name: form.middle_name,
//       last_name: form.last_name,

//       owner_first_name: form.owner_first || "",
//       owner_middle_name: form.owner_middle || "",
//       owner_last_name: form.owner_last || "",

//       business_name: form.business_name || form.company_name || "",
//       owner_contact: form.owner_contact || form.contact_phone,
//       owner_email: form.owner_email || form.contact_email,

//       email: form.official_email || form.contact_email || "",
//       phone: form.phone_no || form.contact_phone,
//       password: "123456",

//       address_line1: form.address1,
//       address_line2: form.address2,
//       city: form.city,
//       district: form.district,
//       state: form.state,
//       location: form.location,
//       taluka: form.taluka,
//       pincode: form.pincode,

//       pan_number: form.pan_no || form.pan || "",
//       gst: form.gst || "",
//       remark: form.remark || "", // include remark
//     };

//     try {
//       const response = await axios.post(
//         "${BASE_URL}/common/signup",
//         payload
//       );

//       if (response.data.status === true) {
//         toast.success(
//           `${type.charAt(0).toUpperCase() + type.slice(1)} created successfully!`
//         );
//         navigate(`/${type}s`);
//       } else {
//         toast.error(response.data.message || "Something went wrong");
//       }
//     } catch (error) {
//       Swal.fire("Error", "Failed to save data.", "error");
//     }
//   };

//   // INPUT RENDER FUNCTION
//   const renderInput = (label, name, typeInput = "text", readOnly = false, options = []) => (
//     <div>
//       <label className="block text-sm font-medium text-slate-700">{label}</label>
//       {typeInput === "select" ? (
//         <select
//           name={name}
//           value={form[name]}
//           onChange={handleChange}
//           disabled={readOnly}
//           className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full 
//             ${readOnly ? "bg-gray-100" : ""} 
//             ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//         >
//           <option value="">Select {label}</option>
//           {options.map((opt) => (
//             <option key={opt} value={opt}>{opt}</option>
//           ))}
//         </select>
//       ) : (
//         <input
//           type={typeInput}
//           name={name}
//           value={form[name]}
//           onChange={handleChange}
//           readOnly={readOnly}
//           maxLength={name === "pincode" ? 6 : undefined}
//           className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full 
//             ${readOnly ? "bg-gray-100" : ""} 
//             ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//         />
//       )}
//       {errors[name] && <p className="text-xs text-red-500 mt-1">{errors[name]}</p>}
//       {loadingPin && name === "pincode" && <p className="text-xs text-blue-600 mt-1">Fetching...</p>}
//     </div>
//   );

//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-5 m-4 mb-10">
//       <h2 className="text-2xl font-semibold text-primary mb-4">
//         Add New {lead?.lead_type}
//       </h2>

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* PERSONAL INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Personal Information</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("First Name", "first_name")}
//             {renderInput("Middle Name", "middle_name")}
//             {renderInput("Last Name", "last_name")}
//             {renderInput("Phone Number", "phone_no")}
//             {renderInput("Official Email", "official_email", "email")}
//             {renderInput("Position", "position", "text", true)}
//           </div>
//         </div>

//         {/* ADDRESS INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Address Details</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Address Line 1", "address1")}
//             {renderInput("Address Line 2", "address2")}
//             {renderInput("Pincode", "pincode")}
//             {renderInput("State", "state", "text", true)}
//             {renderInput("District", "district", "text", true)}
//             {renderInput("Taluka", "taluka")}
//             {renderInput("City", "city")}
//             {renderInput("Location", "location")}
//           </div>
//         </div>

//         {/* BUSINESS INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Business Details</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Business Name", "business_name")}
//             {renderInput("Owner First Name", "owner_first")}
//             {renderInput("Owner Middle Name", "owner_middle")}
//             {renderInput("Owner Last Name", "owner_last")}
//             {renderInput("Owner Contact Number", "owner_contact")}
//             {renderInput("Owner Email ID", "owner_email", "email")}
//             {renderInput("PAN Number", "pan_no")}
//             {lead && lead.remark && renderInput("Remark", "remark")}
//           </div>
//         </div>

//         {/* BUTTONS */}
//         <div className="flex justify-end gap-3">
//           <BlueButton type="button" onClick={() => navigate(`/${type}s`)}>Cancel</BlueButton>
//           <BlueButton type="submit">Save</BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }



// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import BlueButton from "../../../Component/Common/BlueButton";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import toast from "react-hot-toast";

// export default function AddEntityForm() {
//   const navigate = useNavigate();
//   const { type = "agent" } = useParams(); // default type
//   const location = useLocation();
//   const lead = location.state?.lead || null; // lead data from previous page
//   const [loadingPin, setLoadingPin] = useState(false);

//   // --- FORM STATE ---
//   const [form, setForm] = useState({
//     first_name: lead?.name?.split(" ")[0] || "",
//     middle_name: lead?.name?.split(" ")[1] || "",
//     last_name: lead?.name?.split(" ")[2] || "",

//     phone_no: lead?.phone || "",
//     official_email: lead?.email || "",
//     position: type.charAt(0).toUpperCase() + type.slice(1),

//     address1: lead?.address_full || "",
//     address2: "",
//     pincode: lead?.pincode || "",
//     state: lead?.state || "",
//     district: lead?.district || "",
//     taluka: "",
//     city: lead?.district || "",
//     location: lead?.district || "",

//     business_name: lead?.name || "",
//     owner_first: lead?.owner_name?.split(" ")[0] || "",
//     owner_middle: lead?.owner_name?.split(" ")[1] || "",
//     owner_last: lead?.owner_name?.split(" ")[2] || "",
//     owner_contact: lead?.phone || "",
//     owner_email: lead?.email || "",
//     pan_no: "",

//     company_name: "",
//     contact_person: "",
//     contact_phone: "",
//     contact_email: "",
//     pan: "",
//     gst: "",
//     business_type: "Unregister",
//   });

//   const [errors, setErrors] = useState({});

//   // REQUIRED FIELDS BY TYPE
//   const requiredFieldsByType = {
//     agent: [
//       "first_name",
//       "last_name",
//       "phone_no",
//       "official_email",
//       "position",
//       "address1",
//       "pincode",
//     ],

//     retailer: [
//       "business_name",
//       "owner_first",
//       "owner_last",
//       "owner_contact",
//       "owner_email",
//       "pincode",
//       "pan_no",
//     ],

//     company: [
//       "company_name",
//       "contact_person",
//       "contact_phone",
//       "contact_email",
//       "pan",
//       "gst",
//       "pincode",
//     ],
//   };

//   // HANDLE INPUT CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({ ...prev, [name]: value }));

//     // pincode fetch
//     if (name === "pincode" && value.length === 6) fetchPinDetails(value);

//     // live validation
//     validateField(name, value);
//   };

//   // FETCH PINCODE
//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);
//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           city: res.data.city || "",
//           taluka: res.data.taluk || "",
//         }));
//         setErrors((prev) => ({ ...prev, pincode: "" }));
//       } else {
//         setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
//         Swal.fire("Invalid Pincode", "Enter a correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   // VALIDATE A SINGLE FIELD
//   const validateField = (name, value) => {
//     let error = "";

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[6-9]\d{9}$/;
//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

//     const requiredFields = requiredFieldsByType[type] || [];

//     // Only validate fields required for this TYPE
//     if (requiredFields.includes(name)) {
//       if (!value.trim()) error = "This field is required";
//     }

//     // Specific rules
//     if (value.trim()) {
//       if (["phone_no", "owner_contact", "contact_phone"].includes(name)) {
//         if (!phoneRegex.test(value)) error = "Invalid 10-digit phone number";
//       }

//       if (
//         ["official_email", "owner_email", "contact_email"].includes(name) &&
//         !emailRegex.test(value)
//       ) {
//         error = "Invalid email format";
//       }

//       if (["pan", "pan_no"].includes(name) && !panRegex.test(value)) {
//         error = "Invalid PAN format";
//       }

//       if (name === "pincode" && value.length !== 6) {
//         error = "Pincode must be 6 digits";
//       }
//     }

//     setErrors((prev) => ({ ...prev, [name]: error }));
//     return error === "";
//   };

//   // VALIDATE ENTIRE FORM BASED ON TYPE
//   const validateForm = () => {
//     let valid = true;
//     const required = requiredFieldsByType[type] || [];

//     required.forEach((field) => {
//       if (!validateField(field, form[field])) valid = false;
//     });

//     return valid;
//   };

//   // SUBMIT FORM
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       Swal.fire("Error", "Fix validation errors before submitting.", "error");
//       return;
//     }

//     const payload = {
//       flag: type,
//       company_id: type === "company" ? null : 1,

//       first_name: form.first_name,
//       middle_name: form.middle_name,
//       last_name: form.last_name,

//       owner_first_name: form.owner_first || "",
//       owner_middle_name: form.owner_middle || "",
//       owner_last_name: form.owner_last || "",

//       business_name: form.business_name || form.company_name || "",
//       owner_contact: form.owner_contact || form.contact_phone,
//       owner_email: form.owner_email || form.contact_email,

//       email: form.official_email || form.contact_email || "",
//       phone: form.phone_no || form.contact_phone,
//       password: "123456",

//       address_line1: form.address1,
//       address_line2: form.address2,
//       city: form.city,
//       district: form.district,
//       state: form.state,
//       location: form.location,
//       taluka: form.taluka,
//       pincode: form.pincode,

//       pan_number: form.pan_no || form.pan || "",
//       gst: form.gst || "",
//     };

//     try {
//       const response = await axios.post(
//         "${BASE_URL}/common/signup",
//         payload
//       );

//       if (response.data.status === true) {
//         toast.success(
//           `${type.charAt(0).toUpperCase() + type.slice(1)} created successfully!`
//         );
//         navigate(`/${type}s`);
//       } else {
//         toast.error(response.data.message || "Something went wrong");
//       }
//     } catch (error) {
//       Swal.fire("Error", "Failed to save data.", "error");
//     }
//   };

//   // INPUT RENDER FUNCTION
//   const renderInput = (
//     label,
//     name,
//     typeInput = "text",
//     readOnly = false,
//     options = []
//   ) => (
//     <div>
//       <label className="block text-sm font-medium text-slate-700">{label}</label>

//       {typeInput === "select" ? (
//         <select
//           name={name}
//           value={form[name]}
//           onChange={handleChange}
//           disabled={readOnly}
//           className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full 
//             ${readOnly ? "bg-gray-100" : ""} 
//             ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//         >
//           <option value="">Select {label}</option>
//           {options.map((opt) => (
//             <option key={opt} value={opt}>
//               {opt}
//             </option>
//           ))}
//         </select>
//       ) : (
//         <input
//           type={typeInput}
//           name={name}
//           value={form[name]}
//           onChange={handleChange}
//           readOnly={readOnly}
//           maxLength={name === "pincode" ? 6 : undefined}
//           className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full 
//             ${readOnly ? "bg-gray-100" : ""} 
//             ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//         />
//       )}

//       {errors[name] && <p className="text-xs text-red-500 mt-1">{errors[name]}</p>}
//       {loadingPin && name === "pincode" && (
//         <p className="text-xs text-blue-600 mt-1">Fetching...</p>
//       )}
//     </div>
//   );

//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-5 m-4 mb-10">
//       <h2 className="text-2xl font-semibold text-primary mb-4">
//         Add New {type.charAt(0).toUpperCase() + type.slice(1)}
//       </h2>

//       <form onSubmit={handleSubmit} className="space-y-8">

//         {/* PERSONAL INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Personal Information
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("First Name", "first_name")}
//             {renderInput("Middle Name", "middle_name")}
//             {renderInput("Last Name", "last_name")}
//             {renderInput("Phone Number", "phone_no")}
//             {renderInput("Official Email", "official_email", "email")}
//             {renderInput("Position", "position", "text", true)}
//           </div>
//         </div>

//         {/* ADDRESS INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Address Details
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Address Line 1", "address1")}
//             {renderInput("Address Line 2", "address2")}
//             {renderInput("Pincode", "pincode")}
//             {renderInput("State", "state", "text", true)}
//             {renderInput("District", "district", "text", true)}
//             {renderInput("Taluka", "taluka")}
//             {renderInput("City", "city")}
//             {renderInput("Location", "location")}
//           </div>
//         </div>

//         {/* BUSINESS INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Business Details
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Business Name", "business_name")}
//             {renderInput("Owner First Name", "owner_first")}
//             {renderInput("Owner Middle Name", "owner_middle")}
//             {renderInput("Owner Last Name", "owner_last")}
//             {renderInput("Owner Contact Number", "owner_contact")}
//             {renderInput("Owner Email ID", "owner_email", "email")}
//             {renderInput("PAN Number", "pan_no")}
//           </div>
//         </div>

//         {/* BUTTONS */}
//         <div className="flex justify-end gap-3">
//           <BlueButton type="button" onClick={() => navigate(`/${type}s`)}>
//             Cancel
//           </BlueButton>
//           <BlueButton type="submit">Save</BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }



// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import BlueButton from "../../../Component/Common/BlueButton";
// import { useNavigate, useParams } from "react-router-dom";
// import toast from "react-hot-toast";

// export default function AddEntityForm() {
//   const navigate = useNavigate();
//   const { type = "agent" } = useParams(); // default type
//   const [loadingPin, setLoadingPin] = useState(false);

//   // --- FORM STATE ---
//   const [form, setForm] = useState({
//     first_name: "",
//     middle_name: "",
//     last_name: "",
//     phone_no: "",
//     official_email: "",
//     position: type.charAt(0).toUpperCase() + type.slice(1), 

//     address1: "",
//     address2: "",
//     pincode: "",
//     state: "",
//     district: "",
//     taluka: "",
//     city: "",
//     location: "",

//     business_name: "",
//     owner_first: "",
//     owner_middle: "",
//     owner_last: "",
//     owner_contact: "",
//     owner_email: "",
//     pan_no: "",

//     company_name: "",
//     contact_person: "",
//     contact_phone: "",
//     contact_email: "",
//     pan: "",
//     gst: "",
//     business_type: "Unregister",
//   });

//   const [errors, setErrors] = useState({});

//   // REQUIRED FIELDS BY TYPE
//   const requiredFieldsByType = {
//     agent: [
//       "first_name",
//       "last_name",
//       "phone_no",
//       "official_email",
//       "position",
//       "address1",
//       "pincode",
//     ],

//     retailer: [
//       "business_name",
//       "owner_first",
//       "owner_last",
//       "owner_contact",
//       "owner_email",
//       "pincode",
//       "pan_no",
//     ],

//     company: [
//       "company_name",
//       "contact_person",
//       "contact_phone",
//       "contact_email",
//       "pan",
//       "gst",
//       "pincode",
//     ],
//   };

//   // HANDLE INPUT CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({ ...prev, [name]: value }));

//     // pincode fetch
//     if (name === "pincode" && value.length === 6) fetchPinDetails(value);

//     // live validation
//     validateField(name, value);
//   };

//   // FETCH PINCODE
//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);
//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           city: res.data.city || "",
//           taluka: res.data.taluk || "",
//         }));
//         setErrors((prev) => ({ ...prev, pincode: "" }));
//       } else {
//         setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
//         Swal.fire("Invalid Pincode", "Enter a correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   // VALIDATE A SINGLE FIELD
//   const validateField = (name, value) => {
//     let error = "";

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[6-9]\d{9}$/;
//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

//     const requiredFields = requiredFieldsByType[type] || [];

//     // Only validate fields required for this TYPE
//     if (requiredFields.includes(name)) {
//       if (!value.trim()) error = "This field is required";
//     }

//     // Specific rules
//     if (value.trim()) {
//       if (["phone_no", "owner_contact", "contact_phone"].includes(name)) {
//         if (!phoneRegex.test(value)) error = "Invalid 10-digit phone number";
//       }

//       if (
//         ["official_email", "owner_email", "contact_email"].includes(name) &&
//         !emailRegex.test(value)
//       ) {
//         error = "Invalid email format";
//       }

//       if (["pan", "pan_no"].includes(name) && !panRegex.test(value)) {
//         error = "Invalid PAN format";
//       }

//       if (name === "pincode" && value.length !== 6) {
//         error = "Pincode must be 6 digits";
//       }
//     }

//     setErrors((prev) => ({ ...prev, [name]: error }));
//     return error === "";
//   };

//   // VALIDATE ENTIRE FORM BASED ON TYPE
//   const validateForm = () => {
//     let valid = true;
//     const required = requiredFieldsByType[type] || [];

//     required.forEach((field) => {
//       if (!validateField(field, form[field])) valid = false;
//     });

//     return valid;
//   };

//   // SUBMIT FORM
//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!validateForm()) {
//     Swal.fire("Error", "Fix validation errors before submitting.", "error");
//     return;
//   }

//   const payload = {
//     flag: type,
//     company_id: type === "company" ? null : 1,

//     first_name: form.first_name,
//     middle_name: form.middle_name,
//     last_name: form.last_name,

//     owner_first_name: form.owner_first || "",
//     owner_middle_name: form.owner_middle || "",
//     owner_last_name: form.owner_last || "",

//     business_name: form.business_name || form.company_name || "",
//     owner_contact: form.owner_contact || form.contact_phone,
//     owner_email: form.owner_email || form.contact_email,

//     email: form.official_email || form.contact_email || "",
//     phone: form.phone_no || form.contact_phone,
//     password: "123456",

//     address_line1: form.address1,
//     address_line2: form.address2,
//     city: form.city,
//     district: form.district,
//     state: form.state,
//     location: form.location,
//     taluka: form.taluka,
//     pincode: form.pincode,

//     pan_number: form.pan_no || form.pan || "",
//     gst: form.gst || "",
//   };

//   try {
//     const response = await axios.post(
//       "${BASE_URL}/common/signup",
//       payload
//     );

//     if (response.data.status === true) {
//       toast.success(`${type.charAt(0).toUpperCase() + type.slice(1)} created successfully!`);
//       navigate(`/${type}s`);
//     } else {
//       toast.error(response.data.message || "Something went wrong");
//     }
//   } catch (error) {
//     Swal.fire("Error", "Failed to save data.", "error");
//   }
// };


//   // INPUT RENDER FUNCTION
//   const renderInput = (label, name, typeInput = "text", readOnly = false, options = []) => (
//     <div>
//       <label className="block text-sm font-medium text-slate-700">{label}</label>

//       {typeInput === "select" ? (
//         <select
//           name={name}
//           value={form[name]}
//           onChange={handleChange}
//           disabled={readOnly}
//           className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full 
//             ${readOnly ? "bg-gray-100" : ""} 
//             ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//         >
//           <option value="">Select {label}</option>
//           {options.map((opt) => (
//             <option key={opt} value={opt}>
//               {opt}
//             </option>
//           ))}
//         </select>
//       ) : (
//         <input
//           type={typeInput}
//           name={name}
//           value={form[name]}
//           onChange={handleChange}
//           readOnly={readOnly}
//           maxLength={name === "pincode" ? 6 : undefined}
//           className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full 
//             ${readOnly ? "bg-gray-100" : ""} 
//             ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//         />
//       )}

//       {errors[name] && <p className="text-xs text-red-500 mt-1">{errors[name]}</p>}
//       {loadingPin && name === "pincode" && (
//         <p className="text-xs text-blue-600 mt-1">Fetching...</p>
//       )}
//     </div>
//   );

//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-5 m-4 mb-10">
//       <h2 className="text-2xl font-semibold text-primary mb-4">
//         Add New {type.charAt(0).toUpperCase() + type.slice(1)}
//       </h2>

//       <form onSubmit={handleSubmit} className="space-y-8">

//         {/* PERSONAL INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Personal Information
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("First Name", "first_name")}
//             {renderInput("Middle Name", "middle_name")}
//             {renderInput("Last Name", "last_name")}
//             {renderInput("Phone Number", "phone_no")}
//             {renderInput("Official Email", "official_email", "email")}
//             {renderInput("Position", "position", "text", true)}
//           </div>
//         </div>

//         {/* ADDRESS INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Address Details
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Address Line 1", "address1")}
//             {renderInput("Address Line 2", "address2")}
//             {renderInput("Pincode", "pincode")}
//             {renderInput("State", "state", "text", true)}
//             {renderInput("District", "district", "text", true)}
//             {renderInput("Taluka", "taluka")}
//             {renderInput("City", "city")}
//             {renderInput("Location", "location")}
//           </div>
//         </div>

//         {/* BUSINESS INFO */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Business Details
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Business Name", "business_name")}
//             {renderInput("Owner First Name", "owner_first")}
//             {renderInput("Owner Middle Name", "owner_middle")}
//             {renderInput("Owner Last Name", "owner_last")}
//             {renderInput("Owner Contact Number", "owner_contact")}
//             {renderInput("Owner Email ID", "owner_email", "email")}
//             {renderInput("PAN Number", "pan_no")}
//           </div>
//         </div>

//         {/* BUTTONS */}
//         <div className="flex justify-end gap-3">
//           <BlueButton type="button" onClick={() => navigate(`/${type}s`)}>
//             Cancel
//           </BlueButton>
//           <BlueButton type="submit">Save</BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }




// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import BlueButton from "../../../Component/Common/BlueButton";
// import { useNavigate, useParams } from "react-router-dom";

// export default function AddEntityForm() {
//   const navigate = useNavigate();
//   const { type = "agent" } = useParams(); // default type
//   const [loadingPin, setLoadingPin] = useState(false);

//   // Unified form
//   const [form, setForm] = useState({
//     // Personal Info
//     first_name: "",
//     middle_name: "",
//     last_name: "",
//     phone_no: "",
//     official_email: "",
//     position: "",

//     // Address Info
//     address1: "",
//     address2: "",
//     pincode: "",
//     state: "",
//     district: "",
//     taluka: "",
//     city: "",
//     location: "",

//     // Business Info
//     business_name: "",
//     owner_first: "",
//     owner_middle: "",
//     owner_last: "",
//     owner_contact: "",
//     owner_email: "",
//     pan_no: "",
//     company_name: "",
//     contact_person: "",
//     contact_phone: "",
//     contact_email: "",
//     pan: "",
//     gst: "",
//     business_type: "Unregister",
//   });

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));

//     if (name === "pincode" && value.length === 6) fetchPinDetails(value);

//     validateField(name, value);
//   };

//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);
//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           city: res.data.city || "",
//           taluka: res.data.taluk || "",
//         }));
//         setErrors((prev) => ({ ...prev, pincode: "" }));
//       } else {
//         setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
//         Swal.fire("Invalid Pincode", "Enter a correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   const validateField = (name, value) => {
//     let error = "";
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[6-9]\d{9}$/;
//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

//     switch (name) {
//       case "first_name":
//       case "last_name":
//       case "position":
//       case "address1":
//       case "business_name":
//       case "owner_first":
//       case "owner_last":
//       case "company_name":
//       case "contact_person":
//         if (!value.trim()) error = "This field is required";
//         break;
//       case "phone_no":
//       case "owner_contact":
//       case "contact_phone":
//         if (!value.trim()) error = "This field is required";
//         else if (!phoneRegex.test(value)) error = "Invalid 10-digit number";
//         break;
//       case "official_email":
//       case "owner_email":
//       case "contact_email":
//         if (!value.trim()) error = "This field is required";
//         else if (!emailRegex.test(value)) error = "Invalid email address";
//         break;
//       case "pincode":
//         if (!value.trim()) error = "This field is required";
//         else if (value.length !== 6) error = "Pincode must be 6 digits";
//         break;
//       case "pan":
//       case "pan_no":
//         if (!value.trim()) error = "This field is required";
//         else if (!panRegex.test(value)) error = "Invalid PAN format";
//         break;
//       default:
//         break;
//     }

//     setErrors((prev) => ({ ...prev, [name]: error }));
//     return error === "";
//   };

//   const validateForm = () => {
//     let valid = true;
//     Object.keys(form).forEach((key) => {
//       if (!validateField(key, form[key])) valid = false;
//     });
//     return valid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) {
//       Swal.fire("Error", "Please fix validation errors", "error");
//       return;
//     }

//     const payload = {
//       company_name: form.company_name || form.business_name,
//       contact_person: form.contact_person || form.owner_first + " " + form.owner_last,
//       contact_phone: form.contact_phone || form.owner_contact,
//       contact_email: form.contact_email || form.owner_email,
//       password: "123456",
//       address_line1: form.address1,
//       address_line2: form.address2,
//       city: form.city,
//       state: form.state,
//       district: form.district,
//       pincode: form.pincode,
//       pan: form.pan || form.pan_no,
//       gst: form.gst,
//       business_type: form.business_type,
//     };

//     try {
//       await axios.post("${BASE_URL}/company/add", payload);
//       Swal.fire("Success", `${type.charAt(0).toUpperCase() + type.slice(1)} added successfully!`, "success")
//         .then(() => navigate(`/${type}s`));
//     } catch (err) {
//       Swal.fire("Error", "Failed to save.", "error");
//     }
//   };

//  const renderInput = (label, name, typeInput = "text", readOnly = false, options = []) => (
//   <div>
//     <label className="block text-sm font-medium text-slate-700">{label}</label>

//     {typeInput === "select" ? (
//       <select
//         name={name}
//         value={form[name]}
//         onChange={handleChange}
//         disabled={readOnly}
//         className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full 
//           ${readOnly ? "bg-gray-100" : ""} 
//           ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//       >
//         <option value="">Select {label}</option>
//         {options.map((opt) => (
//           <option key={opt} value={opt}>
//             {opt}
//           </option>
//         ))}
//       </select>
//     ) : (
//       <input
//         type={typeInput}
//         name={name}
//         value={form[name]}
//         onChange={handleChange}
//         readOnly={readOnly}
//         maxLength={name === "pincode" ? 6 : undefined}
//         className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full 
//           ${readOnly ? "bg-gray-100" : ""} 
//           ${errors[name] ? "border-red-500" : "border-slate-300"}`}
//       />
//     )}

//     {errors[name] && <p className="text-xs text-red-500 mt-1">{errors[name]}</p>}
//     {loadingPin && name === "pincode" && <p className="text-xs text-blue-600 mt-1">Fetching...</p>}
//   </div>
// );



//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-5 m-4 mb-10">
//       <h2 className="text-2xl font-semibold text-primary mb-4">
//         Add New {type.charAt(0).toUpperCase() + type.slice(1)}
//       </h2>

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* Personal Info */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Personal Information</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("First Name", "first_name")}
//             {renderInput("Middle Name", "middle_name")}
//             {renderInput("Last Name", "last_name")}
//             {renderInput("Phone Number", "phone_no")}
//             {renderInput("Official Email", "official_email", "email")}
//             {renderInput("Position", "position", "select", false, ["Company", "Agent", "Retailer"])}

//           </div>
//         </div>

//         {/* Address Info */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Address Details</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Address Line 1", "address1")}
//             {renderInput("Address Line 2", "address2")}
//             {renderInput("Pincode", "pincode")}
//             {renderInput("State", "state", "text", true)}
//             {renderInput("District", "district", "text", true)}
//             {renderInput("Taluka", "taluka", "text")}
//             {renderInput("City", "city")}
//             {renderInput("Location", "location")}
//           </div>
//         </div>

//         {/* Business Info */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Business Details</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Business Name", "business_name")}
//             {renderInput("Owner First Name", "owner_first")}
//             {renderInput("Owner Middle Name", "owner_middle")}
//             {renderInput("Owner Last Name", "owner_last")}
//             {renderInput("Owner Contact Number", "owner_contact")}
//             {renderInput("Owner Email ID", "owner_email", "email")}
//             {renderInput("PAN Number", "pan_no")}
//           </div>
//         </div>

//         {/* Buttons */}
//         <div className="flex justify-end gap-3">
//           <BlueButton type="button" onClick={() => navigate(`/${type}s`)}>
//             Cancel
//           </BlueButton>
//           <BlueButton type="submit">Save</BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }


